import { Component, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonInput, ModalController, NavController, ToastController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormArray, ValidatorFn, ValidationErrors } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { UtilService } from '../../../service/util.service';
import { UserProfile } from '../../../models/user-profile.model';
import { VoucherService } from '../voucher.service';
import { Router } from '@angular/router';
import { UserData } from '../../../providers/user-data';
import { RoleAccess } from '../../../models/role-access.model';
import { MyService } from '../../../service/my.service';
import { ProductListVoucherComponentComponent } from '../../../component/product-list-voucher-component/product-list-voucher-component.component';
import { CustomerListComponent } from '../../../component/customer-list/customer-list.component';

export const timeRangeValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
  const startCtrl = group.get('mulai');
  const endCtrl = group.get('selesai');
  const start = startCtrl ? startCtrl.value : null;
  const end = endCtrl ? endCtrl.value : null;
  if (!start || !end) return null; // Belum diisi, jangan error dulu

  const startDate = new Date(start);
  const endDate = new Date(end);

  const startMinutes = startDate.getHours() * 60 + startDate.getMinutes();
  const endMinutes = endDate.getHours() * 60 + endDate.getMinutes();

  console.log('start', start, '=>', startMinutes);
  console.log('end', end, '=>', endMinutes);

  return startMinutes >= endMinutes ? { invalidTimeRange: true } : null;
};

@Component({
  selector: 'app-voucher-create',
  templateUrl: './voucher-create.page.html',
  styleUrls: ['./voucher-create.page.scss'],
})
export class VoucherCreatePage implements OnInit {

  token: any;
  userProfile: UserProfile = new UserProfile();
  formVoucherCreate: FormGroup;
  voucherCode: any[] = [];
  nominalVoucher: any = 0;
  roleAccess = new RoleAccess();
  voucherType:any='';
  msgMaxInputDigit:any='';
  msgMaxPercent:any='';
  productListDisplay:any='';
  customerListDisplay:any='';
  customerIdDisplay:any='';
  activeCounterList:any[]=[];
  counterList:any='';
  mstProductList:any[]=[];
  today: string;
  activeTierList :any[]=[];
  activeMemberList : any[]=[];
  
  days = ['Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu', 'Minggu'];

  constructor(
    private fb: FormBuilder,
    private storage: Storage,
    private utilService: UtilService,
    private alertController: AlertController,
    private toastCtrl: ToastController,
    private navCtrl: NavController,
    private voucherService: VoucherService,
    private userData: UserData,
    private router: Router,
    private myService:MyService,
    private modalController:ModalController
  ) {
  // ✅ Ambil waktu lokal dan konversi ke format YYYY-MM-DD (tanpa jam)
    const todayDate = new Date();
    const year = todayDate.getFullYear();
    const month = (todayDate.getMonth() + 1).toString().padStart(2, '0');
    const day = todayDate.getDate().toString().padStart(2, '0');

    this.today = `${year}-${month}-${day}`; // contoh: "2025-10-16"
  }

  @ViewChild('prefixInput', { static: false }) prefixInput: IonInput;
  @ViewChild('voucherCodeInput', { static: false }) voucherCodeInput: IonInput;
  ngOnInit() {
    this.buildFormVoucherCreate();
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.create!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        else{
          this.utilService.loadingPresent('Harap tunggu...')
          .then(() => {
            let options = {
              "token": this.token,
              "counter_id": this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list
            };
            this.voucherService.getVoucherforCreate(options).subscribe((response) => {
              this.utilService.loadingDismiss();
              this.activeTierList = response.results.tier;
              this.activeMemberList = response.results.member;
              this.activeCounterList = response.results.counter;
              this.mstProductList = response.results.product;
              this.formVoucherCreate.get('voucherType').valueChanges.subscribe(value => {
                this.voucherType = value;
                if (value === 'nominal') {
                  const nominal = this.formVoucherCreate.get('nominal').value || 0;
                  this.formVoucherCreate.get('maxValue').setValue(nominal);
                }
                else if(value=='percent'){
                  let nominalValueWithoutseparator = String(this.formVoucherCreate.get('nominal').value).replace(/[^0-9]/g, '');
                  if(Number(nominalValueWithoutseparator)>100){
                    this.msgMaxPercent='Max 100%';
                  }
                  else{
                    this.msgMaxPercent ='';
                  }
                }
              });
              this.formVoucherCreate.get('nominal').valueChanges.subscribe(nominalValue => {
                if (this.formVoucherCreate.get('voucherType').value === 'nominal') {
                  this.formVoucherCreate.get('maxValue').setValue(nominalValue || 0);
                }
      
              });
            });
          });
        }
      }
    });
  }
  minDateToday(control: AbstractControl) {
  if (!control.value) return null;

  const selected = new Date(control.value);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  selected.setHours(0, 0, 0, 0);

  return selected < today ? { dateBeforeToday: true } : null;
}

  buildFormVoucherCreate() {
    this.formVoucherCreate = this.fb.group({
      title:[null, Validators.required],
      codeType:[null,Validators.required],
      prefix:['', Validators.pattern(/^[a-zA-Z0-9-_]*$/)],
      sharedCodeMethod:[null],
      voucher_code:[null],
      voucherType:[null,Validators.required],
      startDate: [null,  [Validators.required, this.minDateToday]],
      voucherTotal: [0, [Validators.required, Validators.min(1)]],
      numberLength: [0, Validators.required],
      maxValue: [0],
      minSpend: [0],
      nominal: [0, [Validators.required, Validators.min(1)]],
      endDate: [null, Validators.required],
      productType:[null],
      productList:[null],
      counterType:[null,Validators.required],
      counterList:[null],
      tipePenerapan:[null, Validators.required],
      tipePenerima:[null, Validators.required],
      tipeMember:[],
      tierIdList:[],
      customerIdList:[],
      productIdList:[],
      tipeKhusus: [''],
      tanggal_khusus: this.fb.array([]),
      hari_khusus: this.fb.array([]),
    });
    
    this.formVoucherCreate.get('startDate')!.valueChanges.subscribe((start) => {
      const endDateControl = this.formVoucherCreate.get('endDate');
      const end = endDateControl!.value;
      if (start && end && new Date(start) > new Date(end)) {
        endDateControl!.setValue(null);
      }
    });
    this.formVoucherCreate.get('tipePenerapan')!.valueChanges.subscribe(() => {
      const tipePenerapan = this.formVoucherCreate.get('tipePenerapan')!.value;
      const productTypeControl = this.formVoucherCreate.get('productType')!;
      if (tipePenerapan === 'per_produk') {
        productTypeControl.setValidators([Validators.required]);
      } else {
        productTypeControl.clearValidators();
        productTypeControl.setValue(null); // reset kalau tidak dipakai
      }
      productTypeControl.updateValueAndValidity();
    });
    this.formVoucherCreate.get('productType')!.valueChanges.subscribe(() => {
      const tipeProduct = this.formVoucherCreate.get('productType')!.value;
      const productIdList = this.formVoucherCreate.get('productIdList')!;
      if (tipeProduct == '1') {
        productIdList.setValidators([Validators.required]);
      } else {
        productIdList.clearValidators();
        productIdList.setValue(null);
      }
      productIdList.updateValueAndValidity();
    });
    this.formVoucherCreate.get('tipePenerima')!.valueChanges.subscribe(() => {
      const tipePenerima = this.formVoucherCreate.get('tipePenerima')!.value;
      const tipeMember = this.formVoucherCreate.get('tipeMember')!;
      if (tipePenerima === 'member') {
        tipeMember.setValidators([Validators.required]);
      } else {
        tipeMember.clearValidators();
        tipeMember.setValue(null); // reset kalau tidak dipakai
      }
      tipeMember.updateValueAndValidity();
    });
    this.formVoucherCreate.get('tipeMember')!.valueChanges.subscribe(() => {
      const tipeMember = this.formVoucherCreate.get('tipeMember')!.value;
      const tierIdList = this.formVoucherCreate.get('tierIdList')!;
      const customerIdList = this.formVoucherCreate.get('customerIdList')!;
      if (tipeMember === 'tier_tertentu') {
        tierIdList.setValidators([Validators.required]);          
        customerIdList.clearValidators();
        customerIdList.setValue(null);
      }
      else if (tipeMember === 'member_tertentu') {
        customerIdList.setValidators([Validators.required]);
        tierIdList.clearValidators();
        tierIdList.setValue(null);
      } else {
        tierIdList.clearValidators();
        tierIdList.setValue(null);
        customerIdList.clearValidators();
        customerIdList.setValue(null);
      }
      tierIdList.updateValueAndValidity();
      customerIdList.updateValueAndValidity();          
    });    
    this.formVoucherCreate.get('counterType')!.valueChanges.subscribe(() => {
      const counterType = this.formVoucherCreate.get('counterType')!.value;
      const counterIdList = this.formVoucherCreate.get('counterList')!;
      if (counterType == '1') {
        counterIdList.setValidators([Validators.required]);
      } else {
        counterIdList.clearValidators();
        counterIdList.setValue(null);
      }
      counterIdList.updateValueAndValidity();
    });
  }
  
  onChangePrice(columnname:any){ 
    let cur= this.formVoucherCreate.getRawValue()[columnname];
    let curWithSeparator='0';
    if(cur!='0' && cur!='' && cur!=null){
      curWithSeparator = this.myService.separator(cur);
      curWithSeparator = String(curWithSeparator).replace(/[^0-9,.]/g, '');
    }
    if (columnname=='numberLength'){
      let curWithoutseparator = String(cur).replace(/[^0-9]/g, '');
                
      if(Number(curWithoutseparator)>10){
        this.msgMaxInputDigit='Max 10 Digit';
      }
      else{
        this.msgMaxInputDigit ='';
      }
    }
    if(columnname=='nominal' || columnname=='voucherType'){
      const voucherForm = this.formVoucherCreate.getRawValue();
      let nominalValueWithoutseparator = String(this.formVoucherCreate.get(columnname).value).replace(/[^0-9]/g, '');
      if(voucherForm.voucherType=='percent' && Number(nominalValueWithoutseparator)>100){
        this.msgMaxPercent='Max 100%';
      }
      else{
        this.msgMaxPercent ='';
      }
    }
    this.formVoucherCreate.patchValue({[columnname]:curWithSeparator});
  }
  generateVoucher() {
    if(this.msgMaxPercent!==''){
      this.showAlertMessage('Max Percent tidak valid')
    }
    else if( this.msgMaxInputDigit!=''){
      this.showAlertMessage('Max Input Digit tidak valid');
    }
    else{
      this.utilService.loadingPresent('Harap tunggu...')
      .then(() => {
        const voucherForm = this.formVoucherCreate.getRawValue();
        let lengthCode: any = String(voucherForm.numberLength).replace(/[^0-9]/g, '');
        let totalCode: any = String(voucherForm.voucherTotal).replace(/[^0-9]/g, '');
        this.nominalVoucher = String(voucherForm.nominal).replace(/[^0-9]/g, '');
        let codeType= voucherForm.codeType
        this.voucherCode = [];

        if(totalCode !== 0 && lengthCode !== 0) {
          let minValue: any = '1';
          let maxValue: any = '9';
          for(let x = 1; x < lengthCode; x++) {
            minValue = minValue + '0';
            maxValue = maxValue + '9';
          }

          let options = {
            "token": this.token,
            "min_value": minValue,
            "max_value": maxValue,
            "total_code": totalCode,
            "prefix":voucherForm.prefix,
            "tipe_kode_voucher":codeType
          };

          this.voucherService.getGenerateVoucher(options).subscribe((response) => {
            this.utilService.loadingDismiss();
            if(response.status.code === 200) {
              if(response.results.length>0){
                this.voucherCode = response.results;
                this.storeVouchers();
              }
              else{
                this.toastCtrl.create({ duration: 2000, message: response.message }).then(t => t.present());
              }
            }
          }, () => {
            this.utilService.loadingDismiss();
            this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
          });
        } else {
          this.utilService.loadingDismiss();
          this.toastCtrl.create({ duration: 2000, message: 'Silahkan isi jumlah digit dan jumlah kode voucher terlebih dahulu' }).then(t => t.present());
        }
      });
    }
  }

 async checkExistingCode(): Promise<string> {
  const voucherForm = this.formVoucherCreate.getRawValue();
  let voucherCode = voucherForm.voucher_code;
  if(voucherCode!=''){
    let options = {
      "voucher_code": voucherCode,
      "token": this.token
    };
    try {
      const response = await this.voucherService.getVoucherByCode(options).toPromise();      
      if (response.results.data.length > 0) {
        console.log('Voucher code already exists');
        return 'exist';
      } else {
        return 'ok';
      }
    } catch (error) {
      console.error('Error checking code:', error);
      return 'error';
    }
  }
  else{
    return 'ok';
  }
}


  async inputVoucher() {
    //cek dulu apakah kode voucher sudah ada di db atau belum, kalau udah ada ndak boleh bikin lagi
    const checkExistingCode = await this.checkExistingCode();
    if(checkExistingCode=='ok'){
      let cur= this.formVoucherCreate.getRawValue()['codeType'];
      let sharedCodeMethod = this.formVoucherCreate.getRawValue()['sharedCodeMethod'];
      if(cur=='unique' || (cur=='shared' && sharedCodeMethod=='auto')){
        this.generateVoucher();
      }
      else{
        const jumlahvoucher = parseInt(this.formVoucherCreate.get('voucherTotal').value, 10);
        if (!isNaN(jumlahvoucher) && jumlahvoucher > 0) {
          const codev = this.formVoucherCreate.get('voucher_code').value;
          for (let i = 0; i < jumlahvoucher; i++) {
            this.voucherCode.push(codev);
          }
        } else {
          console.warn('Jumlah voucher tidak valid');
        }
        this.storeVouchers();
      }
    }
    else{
      this.showAlertMessage("Kode voucher sudah digunakan. Silakan gunakan kode lain.")
    }
  }

  storeVouchers(){
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const voucherForm = this.formVoucherCreate.getRawValue();
      let startDateConvert = this.utilService.convertDate(voucherForm.startDate);
      let newStartDate = startDateConvert.years + '-' + startDateConvert.months + '-' + startDateConvert.dates;
      
      let endDateConvert = this.utilService.convertDate(voucherForm.endDate);
      let newEndDate = endDateConvert.years + '-' + endDateConvert.months + '-' + endDateConvert.dates;
      let maxValue = String(this.formVoucherCreate.get('maxValue').value).replace(/[^0-9]/g, '');
      let minSpend = String(this.formVoucherCreate.get('minSpend').value).replace(/[^0-9]/g, '');
      let voucherValue = String(this.formVoucherCreate.get('nominal').value).replace(/[^0-9]/g, '');
    
      let tipe_kode_voucher = voucherForm.codeType
      let prefix = voucherForm.prefix;
      let digit_diluar_prefix = voucherForm.numberLength;
      let jumlah_generate_voucher = String(voucherForm.voucherTotal.replace(/[^0-9]/g, ''));
      let productType = voucherForm.productType;
      let counterType = voucherForm.counterType;
      let counterList = counterType=='1' ? voucherForm.counterList : [];
      let tierList = voucherForm.tipeMember=='tier_tertentu' ? voucherForm.tierIdList : [];
      let listCounterId='';
      let listTierId='';
      
      let tipePenerapan = voucherForm.tipePenerapan;
      let tipePenerima = voucherForm.tipePenerima;
      let tipeMember = voucherForm.tipeMember;
      if(counterList.length > 0) {
        for(let i = 0; i < counterList.length; i++) {
          listCounterId = listCounterId + counterList[i].id;
          if((i+1) !== counterList.length) {
            listCounterId = listCounterId + ',';
          }
        }
      }
      if(tierList.length > 0) {
        for(let i = 0; i < tierList.length; i++) {
          listTierId = listTierId + tierList[i].id;
          if((i+1) !== tierList.length) {
            listTierId = listTierId + ',';
          }
        }
      }
      
      let payload: any = {};
      if (voucherForm.hari_khusus.length>0) {
        payload.hariKhusus = voucherForm.hari_khusus
          .map((h: any) => ({
            hari: h.hari,
            range: h.jam.map((r: any) => ({
              mulai: r.mulai,
              selesai: r.selesai,
            })),
          }));
      } else  if (voucherForm.tanggal_khusus.length>0) {
          payload.tanggalKhusus =  voucherForm.tanggal_khusus.map((t: any) => ({
          tanggal: t.tanggal,
          range: t.jam.map((r: any) => ({
            mulai: r.mulai,
            selesai: r.selesai,
          })),
        }));
      }

      let options={
          "title":voucherForm.title,
          "token": this.token,
          "tipe_kode_voucher": tipe_kode_voucher,
          "digit_diluar_prefix": digit_diluar_prefix,
          "jumlah_generate_voucher": jumlah_generate_voucher,
          "prefix":prefix,
          "voucher_code": this.voucherCode,
          "voucher_value":Number(voucherValue),
          "voucher_type":voucherForm.voucherType,
          "start_date": newStartDate,
          "end_date": newEndDate,
          "maximum_value":Number(maxValue),
          "minimum_spend":Number(minSpend),
          "voucher_category": 'general',
          "voucher_status":'active',
          "created_by": this.userProfile.username,
          "product_type":productType,
          "product_list":this.productListDisplay.replace(/\s+/g, ''),
          "counter_type":counterType,
          "counter_list":listCounterId, 
          "tipe_penerima":tipePenerima,
          "tipe_penerapan":tipePenerapan,
          "tipe_member":tipeMember,
          "customer_id_list":this.customerIdDisplay.replace(/\s+/g, ''),
          "tier_id_list":listTierId,
          "jadwal_berlaku":payload
      }

      this.voucherService.addVoucher(options).subscribe((response) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 201) {
          this.showConfirmInput();
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }

  async showAlertMessage(msg:any) {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message:msg,
      buttons: [
        {
          text: 'Close',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }
  async showConfirmInput() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Data sudah tersimpan!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.navCtrl.navigateForward(['/voucher']);;
          }
        }
      ]
    });

    await alert.present();
  }

 
  async openProductList(index: any, action: any) {
    const modal = await this.modalController.create({
      component: ProductListVoucherComponentComponent,
      componentProps: {
        'token':this.token,
        'mstProductList': this.mstProductList,
        'selectedProduct':this.productListDisplay,
        'viewOnly':'N'
      },
      backdropDismiss: false
    });
 
    modal.onDidDismiss().then((modelData) => {
      if (modelData.data !== '') {
        let dataProduct: any[] = modelData.data;
        let productList: string = '';
        let productListDisplay: string = '';
        let productType:string='';
 
        if(dataProduct.length > 0) {
          for(let i = 0; i < dataProduct.length; i++) {
            productList = productList + dataProduct[i].id;
            productListDisplay = productListDisplay + dataProduct[i].id;
            productType = productType+dataProduct[i].type;
            if((i+1) !== dataProduct.length) {
              productList = productList + ';';
              productType=productType+';';
              productListDisplay = productListDisplay + ',';
            }
          }
        }
        this.productListDisplay = productListDisplay;
      }
      else{
        this.productListDisplay ='';
      }
      this.formVoucherCreate.get('productIdList').setValue(this.productListDisplay);
    });
    return await modal.present();
  }
  async openCustomerList() {
    const modal = await this.modalController.create({
       component: CustomerListComponent,
       componentProps: {
         'token':this.token,
         'activeMemberList': this.activeMemberList,
         'customerIdDisplay':this.customerIdDisplay,
         'viewOnly':'N'
       },
       backdropDismiss: false
    });
 
    modal.onDidDismiss().then((modelData) => {
      if (modelData.data !== '') {
        let dataCustomer: any[] = modelData.data;
        let customerListDisplay: string = '';
        let customerIdDisplay :string='';
        if(dataCustomer.length > 0) {
          for(let i = 0; i < dataCustomer.length; i++) {
            customerListDisplay = customerListDisplay + dataCustomer[i].phone ;
            customerIdDisplay = customerIdDisplay + dataCustomer[i].id ;
            if((i+1) !== dataCustomer.length) {
              customerListDisplay = customerListDisplay + ',';
              customerIdDisplay = customerIdDisplay + ',';
            }
          }
        }
        this.customerListDisplay = customerListDisplay;
        this.customerIdDisplay = customerIdDisplay;
      }
      else{
        this.customerListDisplay = '';
        this.customerIdDisplay = '';
      }
      this.formVoucherCreate.get('customerIdList').setValue(this.customerIdDisplay);
    });
    return await modal.present();
  }
  
    
  selectCounter(event){
    console.log(event.value);
    this.counterList = [];//event.value.id;
  }

  // Filter input saat user mengetik/paste
  
  onPrefixInput(event: any,column:any) {
    const inputValue = event.target.value || '';
    const filteredValue = inputValue.replace(/[^a-zA-Z0-9-_]/g, '');

    // Hanya update jika ada perubahan
    if (inputValue !== filteredValue) {
      // Update form control (tanpa trigger event berlebihan)
      this.formVoucherCreate.get(column).setValue(filteredValue, { emitEvent: false });

      // Update DOM input (langsung)
      if (column=='prefix' && this.prefixInput && this.prefixInput.getInputElement) {
        this.prefixInput.getInputElement().then(nativeInput => {
          nativeInput.value = filteredValue;
        });
      }
      if (column=='voucher_code' && this.voucherCodeInput && this.voucherCodeInput.getInputElement) {
        this.voucherCodeInput.getInputElement().then(nativeInput => {
          nativeInput.value = filteredValue;
        });
      }
      
    }
  }
  
  
  // ====== Tanggal Khusus ======
  get tanggalKhusus(): FormArray {
    return this.formVoucherCreate.get('tanggal_khusus') as FormArray;
  }

  addTanggal() {
    this.tanggalKhusus.push(
      this.fb.group({
        tanggal: [''],
        jam: this.fb.array([]),
      })
    );
  }

  jamTanggalArray(i: number): FormArray {
    return this.tanggalKhusus.at(i).get('jam') as FormArray;
  }

  addJamTanggal(i: number) {
    this.jamTanggalArray(i).push(this.fb.group(
      { mulai: [''], selesai: [''] }, { validators: timeRangeValidator }));
  }

  // ====== Hari Khusus ======
  get hariKhusus(): FormArray {
    return this.formVoucherCreate.get('hari_khusus') as FormArray;
  }

  addHari(hari: string) {
    this.hariKhusus.push(
      this.fb.group({
        hari: [hari],
        jam: this.fb.array([]),
      })
    );
  }

  jamHariArray(i: number): FormArray {
    return this.hariKhusus.at(i).get('jam') as FormArray;
  }

  addJamHari(i: number) {
    this.jamHariArray(i).push(this.fb.group({ mulai: [''], selesai: [''] }, { validators: timeRangeValidator }));
    
  }

  removeJamHari(i: number, j: number) {
    this.jamHariArray(i).removeAt(j);
  }
  isHariActive(day: string): boolean {
    return this.hariKhusus.value.some((h: any) => h.hari === day);
  }

  toggleHari(day: string, checked: boolean) {
    const index = this.hariKhusus.value.findIndex((h: any) => h.hari === day);
    if (checked && index === -1) {
      this.addHari(day);
    } else if (!checked && index !== -1) {
      this.hariKhusus.removeAt(index);
    }
  }
   // === Reset saat tipe berubah ===
  onTipeChange(value: string) {
    if (value === 'tanggal') {
      this.hariKhusus.clear();
    } else if (value === 'hari') {
      this.tanggalKhusus.clear();
    }
  }

  submitForm() {
    const data = this.formVoucherCreate.value;
    console.log(data);
    let payload: any = {};
    
    if (data.hari_khusus.length>0) {
      payload.hariKhusus = data.hari_khusus
        .map((h: any) => ({
          hari: h.hari,
          range: h.jam.map((r: any) => ({
            mulai: r.mulai,
            selesai: r.selesai,
          })),
        }));
    } else  if (data.tanggal_khusus.length>0) {
        payload.tanggalKhusus =  data.tanggal_khusus.map((t: any) => ({
        tanggal: t.tanggal,
        range: t.jam.map((r: any) => ({
          mulai: r.mulai,
          selesai: r.selesai,
        })),
      }));
    }
    console.log('Payload JSON:', payload);
  }
}
